import { Component, OnInit, Renderer2, effect, inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { EventTypes } from 'src/app/core/constants/event-types';
import { Validator } from 'src/app/core/constants/validators';
import { CreateWebhookCommand, WebhookType } from '../../../../core/api/models';
import { BaseFormPageComponent } from '../../../shared/base/components/base-form-page.component';
import { WebhookDto } from './../../../../core/api/models/webhook-dto';
import { WebhookService } from './../../../../core/api/services/webhook.service';
import { FormPageConfig } from './../../../../core/models/form-page-config.model';
import { BaseFormModule } from 'src/app/shared/components/base/base-component/base-form.module';

@Component({
    selector: 'app-web-hook-form',
    templateUrl: './web-hook-form.component.html',
    imports: [BaseFormModule]
})
export class WebHookFormComponent
  extends BaseFormPageComponent
  implements OnInit
{
  //#region Properties

  protected currentService = inject(WebhookService);
  formPageConfig: FormPageConfig<WebhookDto> = {};
  model: CreateWebhookCommand = {};
  get WebhookType() {
    return WebhookType;
  }

  receiveSampleCode = {
    to: this.translate.instant('pages.webhook.form.to'), //"خط اختصاصی",
    from: this.translate.instant('pages.webhook.form.from'), //"شماره ارسال کننده",
    text: this.translate.instant('pages.webhook.form.text'), //"متن پیام",
    receivedDate: this.translate.instant('pages.webhook.form.receivedDate'), //"تاریخ دریافت",
  };

  deliverySampleCode = {
    messageId: this.translate.instant('pages.webhook.form.messageId'), //"شناسه صندوق ارسال",
    toNumber: this.translate.instant('pages.webhook.form.toNumber'), //"شماره تلفن گیرنده پیام",
    status: this.translate.instant('pages.webhook.form.status'), //"وضعیت "
  };

  jsonSampleCode;

  //#endregion

  constructor(
    protected translate: TranslateService,
    private renderer: Renderer2
  ) {
    super();
    effect(() => {
      this.getJsonSampleCode();
    });
  }

  ngOnInit() {
    try {
      super.ngOnInit();
      this.getJsonSampleCode();
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  getJsonSampleCode() {
    try {
      const webhookSampleCode = document.getElementById('webhookSampleCode');
      webhookSampleCode.innerHTML = '';
      this.renderer.setProperty(webhookSampleCode, 'innerHTML', '');

      switch (this.model.webhookType) {
        case WebhookType.Receive:
          this.jsonSampleCode = this.receiveSampleCode;
          break;
        case WebhookType.Delivery:
          this.jsonSampleCode = this.deliverySampleCode;
          break;
        default:
          this.model.webhookType = WebhookType.Delivery;
          this.jsonSampleCode = this.deliverySampleCode;
          break;
      }
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.setting);
    }
  }

  //#region init methods

  initModel(): void {
    this.model.isActive = false;
    super.initModel();
  }

  initForm(): void {
    this.form = new FormGroup({
      title: new FormControl('', Validators.required),
      tryCount: new FormControl('', Validators.required),
      url: new FormControl('', Validator.url),
      isActive: new FormControl(''),
      webhookType: new FormControl('', Validators.required),
    });
  }

  //#endregion

  //#region api

  //Create
  baseCreateApi(model: any): void {
    this.unSubs();

    this.loading = true;

    this.currentService
      .webhookCreatePost({ body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //Update
  baseUpdateApi(model: any): void {
    this.unSubs();

    this.loading = true;

    model.id = this.formPageConfig.editId;

    this.currentService
      .webhookUpdatePut({ id: this.formPageConfig.editId, body: model })
      .pipe(this.basePipeOperators())
      .subscribe(this.baseObserver);
  }

  //#endregion
}
